{
	"meta": {
		"title": "Contact — UpSquad",
		"description": "Get in touch with the UpSquad team — feature requests, bug reports, account removal or general inquiries."
	},
	"hero": {
		"eyebrow": "Contact",
		"title": "Let's",
		"title_accent": "talk.",
		"subtitle": "Send us a message and we'll get back to you shortly. We typically respond within one business day."
	},
	"form": {
		"name_label": "Your name",
		"name_placeholder": "Jane Doe",
		"email_label": "Email",
		"email_placeholder": "you@company.com",
		"company_label": "Organization (optional)",
		"company_placeholder": "Acme Foundation",
		"subject_label": "What can we help with?",
		"subject_placeholder": "Pick a subject",
		"message_label": "Message",
		"message_placeholder": "Tell us a bit more...",
		"submit": "Send message",
		"submitting": "Sending...",
		"required": "Required",
		"subjects": {
			"feature_request": "Feature request",
			"bug_report": "Bug report",
			"account_removal": "Delete my account (GDPR)",
			"general": "General inquiry"
		},
		"gdpr_notice": "We process account-removal requests within 30 days, in line with GDPR."
	},
	"info": {
		"title": "Other ways to reach us",
		"email_label": "Email",
		"linkedin_label": "LinkedIn",
		"x_label": "X (Twitter)",
		"office": "3618 Walker Ave · Memphis, TN 38152"
	},
	"quick": {
		"demo": {
			"title": "Book a 30-minute demo",
			"body": "See UpSquad live with our team. We'll set up a sandbox community for your org during the call.",
			"cta": "Pick a slot on Calendly"
		},
		"help": {
			"title": "Help center",
			"body": "Setup guides, integration recipes, and how-tos — searchable and always up to date."
		}
	}
}
